export var MICROSOFT_TEAMS_ICON = 'https://turbine-content.s3.us-east-2.amazonaws.com/microsoft-teams-icon.png';
export var GLOBAL_MICROSOFT_TEAMS_CHAT_LINK_BASE = 'https://teams.microsoft.com/l/chat/0/0?users=';
export var DEFAULT_USER_PROFILE = 'https://turbine-content.s3.us-east-2.amazonaws.com/default-profile-picture.png';
